// import BranchLocationStatus from "@DSG/Components/BranchLocationStatus";
import changeBranchPopup from "@DSG/Handlers/ChangeBranch";
import Branch from "@DSG/Icons/Branch";
import Close from "@DSG/Icons/Close";
import ChevronRight from "@DSG/MobiusOverrides/Icons/ChevronRight";
import colorPallete, { bodyFonts, labelFonts } from "@DSG/MobiusOverrides/styles/variables";
import { getWarehouse } from "@DSG/Overrides/Services/WarehouseService";
import ApplicationStateDSG from "@DSG/Store/DSGState";
import useGoogleMaps from "@insite/client-framework/Common/Hooks/useGoogleMaps";
import useWarehouseFilterSearch from "@insite/client-framework/Common/Hooks/useWarehouseFilterSearch";
import useWarehouseGoogleMarkers from "@insite/client-framework/Common/Hooks/useWarehouseGoogleMarkers";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { getGeoCodeFromLatLng } from "@insite/client-framework/Common/Utilities/GoogleMaps/getGeoCodeFromAddress";
import withDynamicGoogleMaps, { HasDynamicGoogleMaps } from "@insite/client-framework/Common/withDynamicGoogleMaps";
// import withDynamicGoogleMaps, { HasDynamicGoogleMaps } from "@DSG/Overrides/Common/withDynamicGoogleMaps";
import { getWarehouses, GetWarehousesApiParameter } from "@insite/client-framework/Services/WarehouseService";
import siteMessage from "@insite/client-framework/SiteMessage";
import loadWarehouses from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import updatePickUpWarehouse from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";
import { getWarehousesDataView } from "@insite/client-framework/Store/Data/Warehouses/WarehousesSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { PaginationModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoCondensedDisplay, {
    AddressInfoCondensedDisplayStyles,
} from "@insite/content-library/Components/AddressInfoCondensedDisplay";
import DistanceDisplay, { DistanceUnitOfMeasure } from "@insite/content-library/Components/DistanceDisplay";
import { WarehouseGoogleMapStyles } from "@insite/content-library/Components/WarehouseGoogleMap";
import WarehouseHoursLink from "@insite/content-library/Components/WarehouseHoursLink";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import Icon from "@insite/mobius/Icon/Icon";
import { Clickable } from "@insite/mobius/index";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Popover from "@insite/mobius/Popover";
import { RadioComponentProps } from "@insite/mobius/Radio";
import { RadioGroupProps } from "@insite/mobius/RadioGroup";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationStateDSG) => {
    const warehousesDataView = getWarehousesDataView(state, state.components.findLocationModal.getWarehousesParameter);
    const session = state.context.session;
    const settings = getSettingsCollection(state);
    const openChangeBranchPopup = state?.changeBranch;
    const locationFinderUrl =getPageLinkByPageType(state, "LocationFinderPage")?.url
    return {
        warehousesDataView,
        session,
        settings,
        openChangeBranchPopup,
        changeBranchPopup,
        locationFinderUrl
    };
};

const mapDispatchToProps = {
    loadWarehouses,
    changeBranchPopup,
    updatePickUpWarehouse,
};
interface OwnProps {
    locationSearchFilter: string;
    onModalClose: () => void;
}
type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasDynamicGoogleMaps;

export interface FindLocationModalStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    modal?: ModalPresentationProps;
    modalContent?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    form?: InjectableCss;
    searchGridContainer?: GridContainerProps;
    searchTextFieldGridItem?: GridItemProps;
    searchTextField?: TextFieldPresentationProps;
    searchRadiusGridItem?: GridItemProps;
    searchRadiusText?: TextFieldPresentationProps;
    searchButtonGridItem?: GridItemProps;
    searchButton?: ButtonPresentationProps;
    searchResultsTextGridItem?: GridItemProps;
    searchResultsText?: TypographyPresentationProps;
    distanceUnitOfMeasureGridItem?: GridItemProps;
    distanceUnitOfMeasureRadioGroup?: RadioGroupProps;
    distanceUnitOfMeasureImperialRadio?: RadioComponentProps;
    distanceUnitOfMeasureMetricRadio?: RadioComponentProps;
    siteMessageGridItem?: GridItemProps;
    siteMessageGeocodeErrorText?: TypographyPresentationProps;
    siteMessageResultsErrorText?: TypographyPresentationProps;
    searchResultGridItem?: GridItemProps;
    searchResultGridContainer?: GridContainerProps;
    searchResultLeftGridItem?: GridItemProps;
    searchResultWarehouseDetailsGridContainer?: GridItemProps;
    searchResultDisplayNumberGridItem?: GridItemProps;
    warehouseDisplayNumberText?: TypographyPresentationProps;
    searchResultWarehouseGridItem?: GridItemProps;
    warehouseNameText?: TypographyPresentationProps;
    branchStatusText?: TypographyPresentationProps;
    searchResultAddressInfoOffsetGridItem?: GridItemProps;
    searchResultAddressInfoIcon?: IconPresentationProps;
    searchResultAddressInfoGridItem?: GridItemProps;
    warehouseAddressInfoCondensed?: AddressInfoCondensedDisplayStyles;
    searchResultLinksAndDistanceContainer?: GridContainerProps;
    searchResultPhoneOffsetGridItem?: GridItemProps;
    searchResultPhoneIcon?: IconPresentationProps;
    searchResultPhoneGridItem?: GridItemProps;
    searchResultPhoneLink?: LinkPresentationProps;
    searchResultSelectGridItem?: GridItemProps;
    searchResultSelectButton?: ButtonPresentationProps;
    searchResultLinksOffsetGridItem?: GridItemProps;
    searchResultHoursGridItem?: GridItemProps;
    warehouseHoursLink?: LinkPresentationProps;
    searchResultGoogleMapsDirectionLinkGridItem?: GridItemProps;
    warehouseGoogleMapsDirectionLink?: LinkPresentationProps;
    searchResultDistanceGridItem?: GridItemProps;
    warehouseDistanceDisplayText?: TypographyPresentationProps;
    searchResultDividerGridItem?: GridItemProps;
    searchResultDivider?: InjectableCss;
    paginationGridItem?: GridItemProps;
    pagination?: PaginationPresentationProps;
    rightColumnGridItem?: GridItemProps;
    currentlySelectedGridContainer?: GridContainerProps;
    currentlySelectedHeaderGridItem?: GridItemProps;
    currentlySelectedHeaderText?: TypographyPresentationProps;
    currentlySelectedDetailsGridItem?: GridItemProps;
    selectedWarehouseGridContainer?: GridContainerProps;
    selectedWarehouseDetailsGridItem?: GridItemProps;
    selectedWarehouseNameText?: TypographyPresentationProps;
    selectedWarehouseAddressDisplay?: AddressInfoCondensedDisplayStyles;
    selectedWarehousePhoneLink?: LinkPresentationProps;
    selectedWarehouseLinksGridItem?: GridItemProps;
    selectedWarehouseLink?: LinkPresentationProps;
    selectedWarehouseGoogleMapsDirectionLink?: LinkPresentationProps;
    selectedWarehouseDistanceText?: TypographyPresentationProps;
    warehouseGoogleMapGridItem?: GridItemProps;
    warehouseGoogleMap?: WarehouseGoogleMapStyles;
    warehouseHoursModal?: ModalPresentationProps;
    hoursContainer?: InjectableCss;
    searchTextFieldContainer?: GridItemProps;
    searchButtonSelected?: ButtonPresentationProps;
    titleContainer?: GridItemProps;
    allBranchLink?: LinkPresentationProps;
    searchLinkContainer?: GridItemProps;
}

export const findLocationModalStyles: FindLocationModalStyles = {
    centeringWrapper: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    modal: {
        sizeVariant: "large",
        cssOverrides: {
            modalTitle: css`
                padding: 0;
            `,
            modalContent: css`
                padding: 0;
            `,
        },
    },
    searchResultPhoneLink: {
        css: css`
            text-decoration: underline;
        `,
    },
    modalContent: {
        gap: 0,
        css: css`
            margin: 0;
            width: auto;
            [data-test-selector*="pickUpLocationModal_warehouseHours_"] {
                display: none;
            }
        `,
    },
    leftColumnGridItem: {
        width: 12,
    },

    titleContainer: {
        width: 12,
        css: css`
            position: relative;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 24px !important;
            padding: 16px;
            [class*="IconWrapper"] {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
            }
        `,
    },

    form: {
        css: css`
            width: 100%;
        `,
    },
    searchGridContainer: {
        gap: 0,
    },
    searchTextFieldContainer: {
        css: css`
            margin-bottom: 8px;
            padding: 0 8px;
            [class*="GridItemStyle"] {
                padding: 0 8px 16px;
            }
            align-items: center;
            label {
                display: none;
            }
            .label {
                white-space: nowrap;
                margin-left: 5px;
                font-weight: 600;
                font-size: 14px;
            }
            [class*="GridItemStyle"] {
                align-items: center;
            }
        `,
    },
    searchTextFieldGridItem: {
        width: 12,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            max-width: 185px;
                            flex-basis: 185px;
                        `,
                    ],
                    "min",
                )}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 50% !important;
                            flex-basis: 50% !important;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    searchRadiusGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            padding-top: 10px;

            [class*="FormInputWrapper"] {
                width: 89%;
                margin-right: 16px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            max-width: 165px;
                            flex-basis: 165px;
                            [class*="FormInputWrapper"] {
                                width: 96px;
                            }
                        `,
                    ],
                    "min",
                )}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 45% !important;
                            flex-basis: 45% !important;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    searchButtonGridItem: {
        width: 12,
        css: css`
            display: block;
            width: 100%;
            padding: 0 16px 24px;
            margin-bottom: 24px;
            border-bottom: 1px solid ${colorPallete.grey400};
        `,
    },
    searchLinkContainer: {
        width: 12,
        css: css`
            display: flex;
            justify-content: space-between;
            font-size: 14px;
        `,
    },
    searchButton: {
        css: css`
            display: block;
            width: 100%;
            background: ${colorPallete.white};
            border: 2px solid ${colorPallete.grey800};
            color: ${colorPallete.grey800}!important;
            padding: 10px 24px;
            margin-bottom: 24px;
            span {
                color: ${colorPallete.grey800}!important;
                font-size: 14px;
            }
            &:hover {
                background: ${colorPallete.white};
                border: 2px solid ${colorPallete.grey800};
                color: ${colorPallete.grey800}!important;
                span {
                    color: ${colorPallete.grey800}!important;
                }
            }
        `,
    },

    allBranchLink: {
        css: css`
            span {
                color: ${colorPallete.primaryRed500}!important;
                font-weight: 600;
                font-size: 14px;
                position: relative;
                display: flex;
                align-items: center;
            }
            &:hover {
                span {
                    color: ${colorPallete.primaryMaroon500}!important;
                }
            }
        `,
    },

    searchResultsTextGridItem: {
        width: 12,
        align: "middle",
        css: css`
            padding: 24px 16px;
            border-bottom: 1px solid ${colorPallete.grey500};
        `,
    },
    distanceUnitOfMeasureGridItem: {
        width: 12,
        align: "middle",
        css: css``,
    },
    distanceUnitOfMeasureRadioGroup: {
        css: css`
            display: inline-block;
            width: 100%;
            flex-direction: row;
            text-align: right;
            & > div {
                display: inline-flex;
            }
        `,
    },
    siteMessageGridItem: {
        width: 12,
        css: css`
            padding: 16px;
        `,
    },
    siteMessageGeocodeErrorText: {
        css: css`
            color: ${colorPallete.grey800};
            font: ${bodyFonts.body2SemiBoldSm.fontWeight} ${bodyFonts.body2SemiBoldSm.fontSize} /
                ${bodyFonts.body2SemiBoldSm.lineHeight} ${bodyFonts.body2SemiBoldSm.fontFamily};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                            line-height: ${bodyFonts.body2SemiBoldLg.lineHeight};
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    siteMessageResultsErrorText: {
        css: css`
            color: ${colorPallete.grey800};
            font: ${bodyFonts.body2SemiBoldSm.fontWeight} ${bodyFonts.body2SemiBoldSm.fontSize} /
                ${bodyFonts.body2SemiBoldSm.lineHeight} ${bodyFonts.body2SemiBoldSm.fontFamily};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                            line-height: ${bodyFonts.body2SemiBoldLg.lineHeight};
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    searchResultGridItem: {
        width: 12,
        css: css``,
    },
    searchResultGridContainer: {
        css: css`
            padding: 24px 0;
            border-bottom: 1px solid ${colorPallete.grey500};
        `,
    },
    searchResultLeftGridItem: {
        width: 12,
        css: css`
            padding: 0 16px;
        `,
    },
    searchResultWarehouseDetailsGridContainer: {
        width: 10,
        css: css`
            padding: 0;
        `,
    },
    searchResultDisplayNumberGridItem: {
        width: 2,
        css: css`
            justify-content: center;
        `,
    },
    warehouseDisplayNumberText: {
        weight: "bold",
    },
    searchResultWarehouseGridItem: {
        css: css`
            width: 100%;
            padding: 0;
            line-height: 1;
        `,
    },
    warehouseNameText: {
        weight: "bold",
        // ellipsis: true,
        css: css`
            font-size: 20px;
            display: inline-block;
            margin-bottom: 8px;
        `,
    },
    branchStatusText: {
        size: labelFonts.label2Regular.fontSize,
        lineHeight: labelFonts.label2Regular.lineHeight,
        weight: labelFonts.label2Regular.fontWeight,
        css: css`
            /* Common */
            display: inline-block;
            padding: 4px 8px;
            border-radius: 4px;
            margin-bottom: 8px;

            /* Open */
            &.branch-open {
                color: ${colorPallete.semanticGreen500};
                border: 1px solid ${colorPallete.semanticGreen500};
                background: ${colorPallete.saveSemanticGreen50};
                font-weight: ${labelFonts.label2SemiBold.fontWeight};
            }

            /* Closed */
            &.branch-closed {
                color: ${colorPallete.semanticError};
                border: 1px solid ${colorPallete.semanticError};
                background: rgba(255, 0, 20, 0.05);
            }
        `,
    },
    searchResultAddressInfoOffsetGridItem: {
        width: 2,
        css: css`
            justify-content: center;
        `,
    },
    searchResultAddressInfoIcon: {
        color: "primary",
    },
    searchResultAddressInfoGridItem: {
        css: css`
            width: 100%;
            padding: 0;
            margin: 0;
            font-size: 14px;
        `,
    },
    searchResultPhoneOffsetGridItem: {
        width: 2,
        css: css`
            justify-content: center;
        `,
    },
    searchResultPhoneIcon: {
        color: "primary",
    },
    searchResultPhoneGridItem: {
        css: css`
            width: 100%;
            padding: 0;
            margin: 0;
            font-size: 14px;
        `,
    },
    searchResultSelectGridItem: {
        width: 12,
        css: css`
            padding: 24px 16px 0 16px;
        `,
    },
    searchResultSelectButton: {
        variant: "tertiary",
        css: css`
            padding: 10px 24px !important;
            font-size: 14px !important;
        `,
    },

    searchButtonSelected: {
        mergeCss: true,
        hoverStyle: {
            background: colorPallete.white,
            color: colorPallete.grey800,
        },
        css: css`
            display: flex;
            align-items: center;
            background: ${colorPallete.white};
            color: ${colorPallete.grey800};
            border: 1px solid ${colorPallete.grey300};
            border-radius: 6px;
            padding: 6px;
            font-size: ${labelFonts.label2SemiBold.fontSize};
            font-weight: ${labelFonts.label2SemiBold.fontWeight};
            &:active {
                color: ${colorPallete.white};
                [class*="IconWrapper"] {
                    color: ${colorPallete.white};
                }
            }
            [class*="IconWrapper"] {
                margin-right: 8px;
            }
        `,
    },

    searchResultLinksAndDistanceContainer: {
        gap: 0,
        css: css`
            width: 100%;
            padding: 0;
            margin: 0;
        `,
    },
    searchResultLinksOffsetGridItem: {
        width: 2,
    },
    searchResultHoursGridItem: {
        width: 3,
    },
    searchResultGoogleMapsDirectionLinkGridItem: {
        width: 3,
    },
    searchResultDistanceGridItem: {
        width: 2,
        css: css`
            white-space: nowrap;
            font-size: 14px;
            padding: 0;
            justify-content: end;
        `,
    },
    searchResultDividerGridItem: {
        width: 12,
    },
    // searchResultDivider: {
    //     css: css`
    //         margin: 10px 0 0;
    //         border: none;
    //         border-bottom: 1px solid ${colorPallete.grey500};
    //         width: 100%;
    //     `,
    // },
    paginationGridItem: {
        width: 12,
        css: css`
            justify-content: center;
        `,
    },
    pagination: {
        cssOverrides: {
            perPageSelect: css`
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: none;
                            `,
                            null,
                            null,
                            null,
                            null,
                        ],
                        "min",
                    )}
            `,
        },
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 6, 7],
    },
    currentlySelectedHeaderGridItem: {
        width: 12,
    },
    currentlySelectedHeaderText: {
        weight: "bold",
    },
    currentlySelectedDetailsGridItem: {
        width: 12,
    },
    selectedWarehouseDetailsGridItem: {
        width: 6,
        css: css`
            flex-direction: column;
        `,
    },
    selectedWarehouseNameText: {
        color: "primary",
        weight: "bold",
    },
    selectedWarehouseLinksGridItem: {
        width: 6,
        css: css`
            flex-direction: column;
        `,
    },
    warehouseGoogleMapGridItem: {
        width: 12,
    },
    warehouseHoursModal: {
        sizeVariant: "small",
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
            `,
            modalContent: css`
                padding: 20px;
            `,
        },
    },
    hoursContainer: {
        css: css`
            white-space: pre-wrap;
        `,
    },
};

const StyledForm = getStyledWrapper("form");
const StyledHr = getStyledWrapper("hr");

const lastFocusableElement: any = null;

const FindLocation = ({
    session,
    settings,
    warehousesDataView,
    loadWarehouses,
    useLoadScript,
    openChangeBranchPopup,
    updatePickUpWarehouse,
    locationSearchFilter,
    changeBranchPopup,
    locationFinderUrl,    
    onModalClose,    
}: Props) => {
    const toasterContext = React.useContext(ToasterContext);
    const [showPopup, setShowPopup] = useState(openChangeBranchPopup.changeBranch);
    const handlePopoverClose = (event?: Event, callParentClose = false) => {
        const body = document.querySelector("body") as HTMLBodyElement;
        callParentClose && popover.current && (popover.current! as any).closePopover();
        setWarehouseSearchFilter("");
        changeBranchPopup({ changeBranch: false });

        if(typeof window !== 'undefined') {
            if (body) {
                body.classList.remove('background-disable');
            }
        }
    };
    const list = React.createRef();
    // const popover = React.createRef<typeof Popover>();
    const popover = React.createRef<any>();

    const clickButton = (<Clickable tabIndex={-1} aria-hidden="true" className="popover-click-button" role="presentation">
                            <VisuallyHidden>
                                {translate('Trigger for Change Branch Modal')}
                            </VisuallyHidden>
                        </Clickable>);
    useEffect(() => {
        let popoverElement: any;
        if (typeof window !== "undefined") {
            popoverElement = document.querySelector(".anybranch");
            if (popoverElement) {
                popoverElement.style.display = "block";
            }
        }

        setShowPopup(openChangeBranchPopup.changeBranch);
        if (openChangeBranchPopup.changeBranch) {
            const b = document.querySelectorAll(".popover-click-button")[0];
            (b as any)?.click();
        }
    }, [openChangeBranchPopup]);

    // const handlePickUpAddressChange = async (pickUpWarehouse: WarehouseModel) => {
    //     await updatePickUpWarehouse({ pickUpWarehouse });
    //     toasterContext.addToast({
    //         body: translate("Pick Up Address Updated"),
    //         messageType: "success",
    //     });
    // };

    const handlePickUpAddressChange = async (dealer: any) => {
        sessionStorage.setItem(
            "selectedLocationData",
            JSON.stringify({
                location: dealer,
            }),
        );
        // var warehouseName = dealer?.properties?.dealerWarehouseName;
        // console.log("warehouseName",warehouseName);
        // getWarehouse(warehouseName).then(async resp => {
        //     if (resp) {
        //         const pickUpWarehouse = resp;
        if (dealer) {
            await updatePickUpWarehouse({ pickUpWarehouse: dealer });
            toasterContext.addToast({
                body: translate("Pick Up Address Updated"),
                messageType: "success",
            });
        } else {
            toasterContext.addToast({
                body: translate("No pick up branch found near this location."),
                messageType: "danger",
            });
        }
        // });
    };

    const [styles] = useState(findLocationModalStyles);
    const [distanceUnitOfMeasure, setDistanceUnitOfMeasure] = useState<DistanceUnitOfMeasure>("Imperial");
    const [warehouseHoursToDisplay, setWarehouseHoursToDisplay] = useState<WarehouseModel | undefined>(undefined);
    const [warehouseHoursToDisplayModalOpen, setWarehouseHoursToDisplayModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [searchLocationFilter, setSearchLocationFilter] = React.useState(locationSearchFilter);

    const { googleMapsApiKey } = settings.websiteSettings;
    // const placeLibrary = ["places"];
    // const { isLoaded } = useLoadScript({ googleMapsApiKey, libraries: [...placeLibrary] });
    const { isLoaded } = useLoadScript({ googleMapsApiKey });
    const {
        googleMap,
        currentLocation,
        setCurrentLocation,
        isGoogleMapsScriptsLoaded,
        setBounds,
        setMapCenter,
        locationKnown,
        setLocationKnown,
    } = useGoogleMaps({
        isLoaded,
        isShown: openChangeBranchPopup.changeBranch,
    });

    // Manage Selected Warehouse
    const [selectedWarehouse, setSelectedWarehouse] = useState<WarehouseModel | undefined>(undefined);
    const [showSelectedWarehouse, setShowSelectedWarehouse] = useState<boolean>(false);
    const [defaultRadius, setDefaultRadius] = useState<number>(0);
    useEffect(() => {
        setSelectedWarehouse(session.pickUpWarehouse || undefined);
    }, [session]);
    // React.useEffect(() => {
    //     setSearchLocationFilter(locationSearchFilter);
    // }, [locationSearchFilter]);
    // Manage Local Warehouses
    const [warehouses, setWarehouses] = useState<WarehouseModel[]>([]);
    const [resultCount, setResultCount] = useState<number>(0);
    const [warehousesPagination, setWarehousesPagination] = useState<PaginationModel | undefined>();

    // Manage Loading Warehouses on State Changes
    const {
        doSearch,
        warehouseSearchFilter,
        setWarehouseSearchFilter,
        radiusSearchFilter,
        setRadiusSearchFilter,
        setPage,
        setPageSize,
    } = useWarehouseFilterSearch({
        loadWarehouses,
        currentLocation,
        setCurrentLocation,
        setLocationKnown,
        defaultRadius,
        selectedWarehouse,
        setSelectedWarehouse,
        setShowSelectedWarehouse,
        excludeCurrentPickupWarehouse: false,
    });

    // Manage Map Markers
    const { mapMarkersElements, currentLocationInfoWindow, warehouseInfoWindow, closeInfoWindows, getWarehouseNumber } =
        useWarehouseGoogleMarkers({
            warehouses,
            warehouseSearchFilter,
            warehousesPagination,
            currentLocation,
            selectedWarehouse,
            showSelectedWarehouse,
        });

    useEffect(() => {
        if (warehousesDataView.value && !warehousesDataView.isLoading) {
            const {
                pagination,
                value: warehouses,
                defaultRadius,
                defaultLatitude,
                defaultLongitude,
            } = warehousesDataView;
            // Find default location
            getGeoCodeFromLatLng(defaultLatitude, defaultLongitude)
                .then(result => {
                    const parts = result[0].formatted_address.split(", ").slice(1).join(", ");
                    setWarehouseSearchFilter(parts);
                })
                .finally(() => {
                    setWarehousesPagination(pagination || undefined);
                    setResultCount(pagination?.totalItemCount || 0);
                    setDefaultRadius(defaultRadius);
                    setRadiusSearchFilter(defaultRadius);
                    setMapCenter(new google.maps.LatLng(defaultLatitude, defaultLongitude));
                    setWarehouses(warehouses || []);
                    setIsLoading(false);
                });
        } else {
            setIsLoading(true);
        }
    }, [warehousesDataView, isGoogleMapsScriptsLoaded]);

    const modalCloseHandler = () => {
         onModalClose();
    };

    // const handleDistanceUnitOfMeasureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const value = event.target.value as DistanceUnitOfMeasure;
    //     setDistanceUnitOfMeasure(value);
    // };

    const handleOpenHoursModal = (warehouse: WarehouseModel) => {
        setWarehouseHoursToDisplayModalOpen(!!warehouse.hours);
        setWarehouseHoursToDisplay(warehouse);
    };

    // const handleHoursModalClose = () => {
    //     setWarehouseHoursToDisplayModalOpen(false);
    //     setWarehouseHoursToDisplay(undefined);
    // };

    const generateOpenWarehouseHoursFor = (warehouse: WarehouseModel) => {
        return () => handleOpenHoursModal(warehouse);
    };

    const generateWarehouseSelectClickHandler = (warehouse: WarehouseModel) => {
        handlePickUpAddressChange(warehouse);
    };

    const isNotFinalResult = (resultIndex: number) => {
        if (!warehousesPagination) {
            return false;
        }
        return warehousesPagination.pageSize > resultIndex + 1;
    };
    // const [geoLocationSearchText, setGeoLocationSearchText] = React.useState("");
    // const [showGeoLocationErrorMessage, setShowGeoLocationErrorMessage] = React.useState(false);
    // const geoLocationErrorMessage = siteMessage("DealerLocator_GeocodeErrorMessage");
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (!isLoading) {
            doSearch(warehouseSearchFilter);
        }
    };
    // const handleSearch = (geoLocationSearch: string, locationSearch: string, radiusSearch?: number) => {
    //     if (!geoLocationSearch) {
    //         setShowGeoLocationErrorMessage(true);
    //         return;
    //     }
    //     setShowGeoLocationErrorMessage(false);
    //     handleGeoLocationSearch(geoLocationSearch);
    //     doSearch(geoLocationSearch);
    // };
    // const handleGeoLocationSearch = (geoLocationSearch: string) => {
    //     setShowGeoLocationErrorMessage(false);
    //     //  setGeoLocationSearchText(geoLocationSearchText);
    //     // Lookup and set currentLocation to this search text
    //     getGeoCodeFromAddress(geoLocationSearch)
    //         .then(result => {
    //             const geocoderResult = result[0];
    //             if (geocoderResult.formatted_address) {
    //                 setGeoLocationSearchText(geocoderResult.formatted_address);
    //             }

    //             // setPage(1);
    //             setCurrentLocation(geocoderResult.geometry.location);
    //         })
    //         .catch(() => {
    //             setShowGeoLocationErrorMessage(true);
    //         });
    // };

    const handleSearchRadiusChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadiusSearchFilter(Number(event.target.value));
    };
    // const handleSearchLocationsChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setSearchLocationFilter(event.target.value);
    // };
    const handleCloseAnySelectBranch = () => {
        let popoverElement: any;
        if (typeof window !== "undefined") {
            popoverElement = document.querySelector(".anybranch");
            if (popoverElement) {
                popoverElement.style.display = "none";
            }
        }
        handlePopoverClose(undefined, true);
        // handlePopoverClose();
    };
    const handleViewallDSGbranchlocations = (event: any) => {
        //window.location.href = "/locations#branchLocationsHeader";
        event.stopPropagation();        
        onModalClose();
    };

    return (
        <>
            <Popover
                isOpen={showPopup}
                controlsId="header_shipToButton-popover"
                ref={popover}
                insideRefs={[list]}
                popoverTrigger={clickButton}
                positionFunction={(element: React.RefObject<HTMLUListElement>) => {
                    return { position: "fixed", top: 0, maxHeight: "100vh", height: "100vh" };
                }}
                contentBodyProps={
                    {
                        ref: list,
                    } as any
                }
                onClose={handlePopoverClose}
                className="popover anybranch no-scroll"
            >
                <GridContainer {...styles.modalContent} data-test-selector="findLocationModal">
                    <GridItem {...styles.titleContainer}>
                        <Typography>{translate("Change Branch ")}</Typography>
                        <Typography className="close-button" onClick={handleCloseAnySelectBranch}>
                            <Icon src={Close} />
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.leftColumnGridItem}>
                        <StyledForm {...styles.form} onSubmit={handleSubmit}>
                            <GridContainer {...styles.searchGridContainer}>
                                <GridContainer {...styles.searchTextFieldContainer}>
                                    {/* <GridItem width={12}>
                                        <TextField
                                            id="searchLocations"
                                            value={searchLocationFilter}
                                            onChange={handleSearchLocationsChanged}
                                            placeholder={translate("Branch Locations")}
                                            data-test-selector="locationSearchForm_searchLocations"
                                        />
                                    </GridItem> */}
                                    <GridContainer>
                                        <GridItem {...styles.searchTextFieldGridItem}>
                                            <SearchLocationsTextField
                                                styles={styles.searchTextField}
                                                warehouseSearchFilter={warehouseSearchFilter}
                                                setWarehouseSearchFilter={setWarehouseSearchFilter}
                                            />
                                        </GridItem>
                                        <GridItem {...styles.searchRadiusGridItem}>
                                            <TextField
                                                {...styles.searchRadiusText}
                                                label={translate("Search Radius")}
                                                value={radiusSearchFilter !== 0 ? radiusSearchFilter : ""}
                                                onChange={handleSearchRadiusChanged}
                                                type="number"
                                                min={0}
                                                placeholder={translate("Search Radius")}
                                                // error={showGeoLocationErrorMessage ? geoLocationErrorMessage : undefined}
                                            />
                                            <span className="label">{translate("Miles")}</span>
                                        </GridItem>
                                    </GridContainer>
                                </GridContainer>
                                <GridItem {...styles.searchButtonGridItem}>
                                    <Button
                                        {...styles.searchButton}
                                        type="submit"
                                        data-test-selector="findLocationModal_searchButton"
                                    >
                                        {translate("Search")}
                                    </Button>
                                    <GridItem {...styles.searchLinkContainer}>
                                        <Link href={`${locationFinderUrl}#branchlocationsheader`} {...styles.allBranchLink} onClick={handleViewallDSGbranchlocations}>
                                            {translate("View all DSG branch locations")}
                                            <Icon src={ChevronRight} />
                                        </Link>
                                       
                                        {/* <Typography {...styles.searchResultsText}>
                                        {translate("{0} Results").replace("{0}", `${resultCount}`)}
                                    </Typography> */}
                                    </GridItem>
                                </GridItem>
                                {/* <GridItem {...styles.distanceUnitOfMeasureGridItem}>
                                    <RadioGroup
                                        {...styles.distanceUnitOfMeasureRadioGroup}
                                        value={distanceUnitOfMeasure}
                                        onChangeHandler={handleDistanceUnitOfMeasureChange}
                                    >
                                        <Radio {...styles.distanceUnitOfMeasureImperialRadio} value="Imperial">
                                            {translate("Miles")}
                                        </Radio>
                                        <Radio {...styles.distanceUnitOfMeasureMetricRadio} value="Metric">
                                            {translate("Kilometers")}
                                        </Radio>
                                    </RadioGroup>
                                </GridItem> */}
                                <GridItem {...styles.siteMessageGridItem}>
                                    {!isLoading && !locationKnown && (
                                        <Typography {...styles.siteMessageGeocodeErrorText}>
                                            {siteMessage("PickUpLocation_GeocodeErrorMessage")}
                                        </Typography>
                                    )}
                                    {!isLoading && locationKnown && warehouses.length === 0 && (
                                        <Typography
                                            data-test-selector="findLocationModal_noresult"
                                            {...styles.siteMessageResultsErrorText}
                                        >
                                            {showSelectedWarehouse
                                                ? siteMessage("PickUpLocation_SelectedLocationIsOnlyResult")
                                                : siteMessage("PickUpLocation_NoResultsMessage")}
                                        </Typography>
                                    )}
                                </GridItem>
                                {/* {(!warehousesDataView || !warehousesDataView.value) && (
                            <GridItem {...styles.searchResultGridItem}>
                                <StyledWrapper {...styles.centeringWrapper}>
                                    <LoadingSpinner {...styles.spinner} />
                                </StyledWrapper>
                            </GridItem>
                        )} */}
                                {warehousesDataView &&
                                    warehousesDataView.value &&
                                    warehouses.map((warehouse, index) => (
                                        <GridItem key={warehouse.id} {...styles.searchResultGridItem}>
                                            <GridContainer
                                                {...styles.searchResultGridContainer}
                                                data-test-selector="findLocationModal_warehouse"
                                                data-test-key={`${warehouse.id}`}
                                            >
                                                <GridItem {...styles.searchResultLeftGridItem}>
                                                    <GridContainer
                                                        {...styles.searchResultWarehouseDetailsGridContainer}
                                                    >
                                                        {/* <GridItem {...styles.searchResultDisplayNumberGridItem}>
                                                            <Typography {...styles.warehouseDisplayNumberText}>
                                                                {getWarehouseNumber(index)}
                                                            </Typography>
                                                        </GridItem> */}
                                                        <StyledWrapper
                                                            {...styles.searchResultWarehouseGridItem}
                                                            data-test-selector={`pickUpLocationModal_warehouseName_${index}`}
                                                        >
                                                            <Typography {...styles.warehouseNameText}>
                                                                {warehouse.description || warehouse.name}
                                                            </Typography>
                                                            {/* <StyledWrapper>
                                                                {warehouse.properties["locationPlaceId"] && (
                                                                    <BranchLocationStatus
                                                                        locationPlaceId={
                                                                            warehouse.properties["locationPlaceId"]
                                                                        }
                                                                    />
                                                                )}
                                                            </StyledWrapper> */}
                                                        </StyledWrapper>
                                                        {/* <GridItem {...styles.searchResultAddressInfoOffsetGridItem}>
                                                            <IconMemo
                                                                {...styles.searchResultAddressInfoIcon}
                                                                src={MapPin}
                                                            />
                                                        </GridItem> */}
                                                        <StyledWrapper {...styles.searchResultAddressInfoGridItem}>
                                                            <AddressInfoCondensedDisplay
                                                                {...styles.warehouseAddressInfoCondensed}
                                                                {...warehouse}
                                                            />
                                                        </StyledWrapper>
                                                        {warehouse.phone && (
                                                            <>
                                                                {/* <GridItem {...styles.searchResultPhoneOffsetGridItem}>
                                                                    <IconMemo
                                                                        src={Phone}
                                                                        {...styles.searchResultPhoneIcon}
                                                                    />
                                                                </GridItem> */}
                                                                <StyledWrapper {...styles.searchResultPhoneGridItem}>
                                                                    <Link
                                                                        href={`tel:${warehouse.phone}`}
                                                                        {...styles.searchResultPhoneLink}
                                                                        target="_blank"
                                                                    >
                                                                        {warehouse.phone}
                                                                    </Link>
                                                                </StyledWrapper>
                                                            </>
                                                        )}
                                                    </GridContainer>

                                                    <GridItem {...styles.searchResultDistanceGridItem}>
                                                        <DistanceDisplay
                                                            {...styles.warehouseDistanceDisplayText}
                                                            distance={warehouse.distance}
                                                            unitOfMeasure={distanceUnitOfMeasure}
                                                            data-test-selector={`pickUpLocationModal_warehouseDistance_${index}`}
                                                        />
                                                    </GridItem>
                                                </GridItem>
                                                {selectedWarehouse?.id === warehouse?.id && (
                                                    <GridItem {...styles.searchResultSelectGridItem}>
                                                        <Button
                                                            {...styles.searchButtonSelected}
                                                            type="button"
                                                            // onClick={generateWarehouseSelectClickHandler(warehouse)}
                                                            data-test-selector="findLocationModal_warehouseSelect"
                                                        >
                                                            <Icon src={Branch} />
                                                            {translate("Shopping this branch")}
                                                        </Button>
                                                    </GridItem>
                                                )}
                                                {selectedWarehouse?.id !== warehouse?.id && (
                                                    <GridItem {...styles.searchResultSelectGridItem}>
                                                        <Button
                                                            {...styles.searchResultSelectButton}
                                                            type="button"
                                                            onClick={() =>
                                                                generateWarehouseSelectClickHandler(warehouse)
                                                            }
                                                            data-test-selector="findLocationModal_warehouseSelect"
                                                            className="btn btn-secondary"
                                                        >
                                                            {" "}
                                                            {translate("Shop this branch")}
                                                        </Button>
                                                    </GridItem>
                                                )}

                                                <GridContainer {...styles.searchResultLinksAndDistanceContainer}>
                                                    <GridItem {...styles.searchResultLinksOffsetGridItem}>
                                                        {/* This is here to give the grid an indentation */}
                                                    </GridItem>
                                                    {warehouse.hours && (
                                                        <GridItem {...styles.searchResultHoursGridItem}>
                                                            <WarehouseHoursLink
                                                                {...styles.warehouseHoursLink}
                                                                warehouse={warehouse}
                                                                onOpenWarehouseHours={generateOpenWarehouseHoursFor(
                                                                    warehouse,
                                                                )}
                                                                data-test-selector={`pickUpLocationModal_warehouseHours_${index}`}
                                                            />
                                                        </GridItem>
                                                    )}
                                                    {/* <GridItem {...styles.searchResultGoogleMapsDirectionLinkGridItem}>
                                                        <GoogleMapsDirectionLink
                                                            {...styles.warehouseGoogleMapsDirectionLink}
                                                            {...warehouse}
                                                        />
                                                    </GridItem> */}
                                                    {/* {isNotFinalResult(index) && (
                                                        <GridItem {...styles.searchResultDividerGridItem}>
                                                            <StyledHr {...styles.searchResultDivider} />
                                                        </GridItem>
                                                    )} */}
                                                </GridContainer>
                                            </GridContainer>
                                        </GridItem>
                                    ))}
                                {/* <GridItem {...styles.paginationGridItem}>
                                    <WarehouseFindLocationPagination
                                        {...styles.pagination}
                                        warehouses={warehouses}
                                        warehousesPagination={warehousesPagination}
                                        setPage={setPage}
                                        setPageSize={setPageSize}
                                    />
                                </GridItem> */}
                            </GridContainer>
                        </StyledForm>
                    </GridItem>
                </GridContainer>
            </Popover>
        </>
    );
};

interface SearchLocationsTextFieldProps {
    styles?: TextFieldPresentationProps;
    warehouseSearchFilter: string;
    setWarehouseSearchFilter: (filter: string) => void;
}

const SearchLocationsTextField = ({
    styles,
    warehouseSearchFilter,
    setWarehouseSearchFilter,
}: SearchLocationsTextFieldProps) => {
    const handleSearchLocationsChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setWarehouseSearchFilter(event.target.value);
    };

    return (
        <TextField
            {...styles}
            label={translate("Search Locations")}
            value={warehouseSearchFilter}
            onChange={handleSearchLocationsChanged}
            placeholder={translate("City, state or ZIP")}
            data-test-selector="findLocation_locationSearch"
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withDynamicGoogleMaps(FindLocation)),
    definition: {
        group: "Header",
        icon: "location-dot",
        displayName: "Change Location Anywhere",
    },
};

export default widgetModule;
